import {connect} from 'react-redux';

import {isTeammateNamespace} from '../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {fetchApiAsync} from '../../../../libs/shared/core/src/services/http/http';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {ApiCardGroups} from '../../../models/api/cardGroupModel';
import {CardModel} from '../../../models/api/cardModel';
import {AppState} from '../../../store/appState';
import {getCompany} from '../../../store/data/company/companySelectors';
import {ContactHeaderAddToGroupDropdown} from './contactHeaderAddToGroupDropdown';

/*
 * Props.
 */

interface ContactHeaderAddToGroupDropdownContainerProps {
  popoverProps: PopoverTransferProps;
  card: CardModel;
}

/*
 * Selectors.
 */

function getNamespace(_state: AppState, props: ContactHeaderAddToGroupDropdownContainerProps) {
  return props.card.namespace;
}

function makeGetFetchCardGroupsAsync() {
  return createSelector(
    [getCompany, getNamespace],
    (company, namespace) =>
      async function fetchAsync() {
        const fetchGroupsUrl = `${company.url}/card_groups`;
        const cardGroups = await fetchApiAsync(ApiCardGroups, fetchGroupsUrl);

        /** For private contacts, only show private groups */
        return isTeammateNamespace(namespace)
          ? cardGroups.filter((group) => group.namespace === namespace)
          : cardGroups;
      },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactHeaderAddToGroupDropdownContainerProps>()(() => ({
  fetchCardGroupsAsync: makeGetFetchCardGroupsAsync(),
}));

export const ContactHeaderAddToGroupDropdownContainer = connect(mapStateToProps)(
  ContactHeaderAddToGroupDropdown,
);
